export default __webpack_public_path__ + "static/c09f03b8f47a546102560d56e40f1d78.svg";